export enum TpnAnalyticsTypes {
  TpnLandingPage = 100,
  TpnMerchantInfoKnown = 101,
  TpnMerchantInfoUnknown = 102,
  TpnSalesMerchantInfoKnown = 103,
  TpnSalesMerchantInfoUnknown = 104,
  TpnMerchantInfoCoalition = 105,
  TpnMerchantInfoQd = 106,
  TpnCreateEnrollment = 107,
  TpnCreateLoyalty = 108,
  TpnTermsAndConditions = 109,
  TpnComplete = 110,
  TpnCallSupport = 197,
  TpnHelpClicked = 198,
  TpnCompleteHelp = 199,
}
